// External
import _ from "lodash";

/**
 * Creates a memoized grade map lookup function
 * This prevents repeated searches through the grades array
 */
export const createGradeMapCache = academicRecordsData => {
  const grades = _.get(
    academicRecordsData,
    "node.transcriptSummary.grades",
    []
  );

  // Create a Map for O(1) lookups instead of O(n) searches
  const gradeMapCache = new Map();

  _.forEach(grades, gradeMap => {
    const id = _.get(gradeMap, "id");
    if (id) {
      gradeMapCache.set(id, gradeMap);
    }
  });

  return {
    /**
     * Get grade map by ID
     */
    getGradeMap: gradeMapId => gradeMapCache.get(gradeMapId) || null,

    /**
     * Check if grade configuration is overridden
     */
    isGradeOverridden: gradeMapId => {
      const gradeMap = gradeMapCache.get(gradeMapId);
      return _.get(gradeMap, "configuration.isOverridden", false);
    },

    /**
     * Check if the grade has any grading period stored as disabled on
     * backend. Used alongside isGradeOverridden to drive the sidebar dot
     * when backend holds disabled-GP state independent of configuration.
     */
    hasBackendDisabledGradingPeriod: gradeMapId => {
      const gradeMap = gradeMapCache.get(gradeMapId);
      return _.some(
        _.get(gradeMap, "gradingPeriods", []),
        gp => _.get(gp, "isEnabled") === false
      );
    },

    /**
     * Get all grade maps
     */
    getAllGradeMaps: () => Array.from(gradeMapCache.values()),

    /**
     * Check if grade exists
     */
    hasGrade: gradeMapId => gradeMapCache.has(gradeMapId),
  };
};
